import { FC } from 'react';

import { getBannerTextTypography } from 'utils/banner/utils';
import { CampaignSource } from 'utils/constants/campaign';

import { Flex, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdvertisementBanReason } from 'components/Banners/components/Banner/components/BannerModeration/components/AdvertisementBanReason';
import { BannerSourceLabel } from 'components/Banners/components/Banner/components/BannerModeration/components/BannerSourceLabel';
import { BANNER_SOURCE_ICONS } from 'components/Banners/components/Banner/sourceIcons';

interface BannedForAllSourcesProps {
    bannedAsAdvertisement: boolean;
    singleBanner: boolean;
    moderationReason: string;
}

const TrlKeys = {
    banned: 'BannersPage.banner.status.banned',
};

const ALL_SOURCES = Object.keys(BANNER_SOURCE_ICONS) as CampaignSource[];

export const BannedForAllSources: FC<BannedForAllSourcesProps> = ({
    bannedAsAdvertisement,
    singleBanner,
    moderationReason,
}) => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    const typography = getBannerTextTypography(isMobile);

    return (
        <Flex gap={4} direction="column">
            <Flex gap={isMobile ? 4 : 8} direction={isMobile ? 'column' : 'row'}>
                <Text typography={typography} style="negative">
                    {trls(TrlKeys.banned)}
                </Text>
                <Flex gap={8} align="center">
                    {ALL_SOURCES.map((source) => (
                        <BannerSourceLabel key={source} source={source} />
                    ))}
                </Flex>
            </Flex>
            <Flex gap={8} direction="column">
                {bannedAsAdvertisement ? (
                    <AdvertisementBanReason singleBanner={singleBanner} />
                ) : (
                    moderationReason.split('\n').map((reason, index) => (
                        <Text typography={typography} key={index}>
                            {reason}
                        </Text>
                    ))
                )}
            </Flex>
        </Flex>
    );
};
